import { render, staticRenderFns } from "./LayoutAdminSidebar.vue?vue&type=template&id=24fcdbda"
import script from "./LayoutAdminSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutAdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./LayoutAdminSidebar.vue?vue&type=style&index=0&id=24fcdbda&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports